var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-config" }, [
    _c(
      "div",
      { staticClass: "tabs", class: [{ tabs2: _vm.wiredNetwork == 0 }] },
      _vm._l(_vm.filteredTabs, function (tab) {
        return _c(
          "div",
          {
            key: tab.index,
            staticClass: "tab-pane",
            class: [
              { "tab-active": _vm.activeName === tab.index },
              _vm.getClassName(tab.index),
              { tabs2: _vm.wiredNetwork == 0 },
            ],
            on: {
              click: function ($event) {
                return _vm.handleTabs(tab.index)
              },
            },
          },
          [_c("div", [_vm._v(_vm._s(tab.title))])]
        )
      }),
      0
    ),
    _c("div", { staticClass: "contain-wrap" }, [
      _c("div", { staticClass: "contain" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeName === 1,
                expression: "activeName === 1",
              },
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "peiwang",
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "content",
                attrs: {
                  model: _vm.formData,
                  "label-width": "80px",
                  "label-position": "left",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "指引说明" } },
                  [
                    _c("el-input", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editStatus,
                          expression: "!editStatus",
                        },
                      ],
                      attrs: {
                        type: "textarea",
                        maxlength: "200",
                        "show-word-limit": "",
                        rows: 6,
                      },
                      model: {
                        value: _vm.formData.cnDescribe,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "cnDescribe", $$v)
                        },
                        expression: "formData.cnDescribe",
                      },
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editStatus,
                            expression: "editStatus",
                          },
                        ],
                        staticClass: "app-text",
                      },
                      [_vm._v(_vm._s(_vm.formData.cnDescribe || "-"))]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-img",
                    class: [{ "no-edit-item": _vm.editStatus }],
                    attrs: { label: "产品图片" },
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.editStatus,
                            expression: "!editStatus",
                          },
                        ],
                        staticClass: "product-img",
                      },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "upload-img",
                            attrs: {
                              action: "/admin/sys-file/upload",
                              headers: _vm.headers,
                              "show-file-list": false,
                              "on-success": _vm.handleAvatarSuccess,
                              "before-upload": _vm.beforeUpload,
                            },
                          },
                          [
                            _vm.formData.pictureUrl
                              ? _c("img", {
                                  staticClass: "uploaded-img",
                                  attrs: {
                                    src:
                                      _vm.uploadUrl || _vm.formData.pictureUrl,
                                  },
                                })
                              : _c("div", [
                                  _c("i", {
                                    staticClass:
                                      "iconfont icon-shangchuantupian",
                                  }),
                                  _c("div", { staticClass: "text" }, [
                                    _vm._v("点击上传"),
                                  ]),
                                ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editStatus,
                            expression: "editStatus",
                          },
                        ],
                      },
                      [
                        _vm.formData.pictureUrl
                          ? _c("img", {
                              attrs: {
                                src: _vm.uploadUrl || _vm.formData.pictureUrl,
                                alt: "",
                              },
                            })
                          : _c("span", [_vm._v("-")]),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "app" }, [
              _c("div", { staticClass: "title" }, [_vm._v("APP内预览效果")]),
              _c("div", { staticClass: "display-area" }, [
                _c("div", { staticClass: "area-title" }, [_vm._v("网络配置")]),
                _c("div", {
                  staticClass: "desc",
                  domProps: { innerHTML: _vm._s(_vm.formattedText) },
                }),
                !_vm.editStatus
                  ? _c("div", { staticClass: "img" }, [
                      _vm.uploadUrl || _vm.formData.pictureUrl
                        ? _c("img", {
                            attrs: {
                              src: _vm.uploadUrl || _vm.formData.pictureUrl,
                              alt: "",
                            },
                          })
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm.editStatus
                  ? _c("div", { staticClass: "img" }, [
                      _vm.formData.pictureUrl
                        ? _c("img", {
                            attrs: { src: _vm.formData.pictureUrl, alt: "" },
                          })
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeName === 2,
                expression: "activeName === 2",
              },
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "youxian",
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "content",
                attrs: {
                  model: _vm.formWiredData,
                  "label-width": "80px",
                  "label-position": "left",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "指引说明" } },
                  [
                    _c("el-input", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editStatus,
                          expression: "!editStatus",
                        },
                      ],
                      attrs: {
                        type: "textarea",
                        maxlength: "200",
                        "show-word-limit": "",
                        rows: 6,
                      },
                      model: {
                        value: _vm.formWiredData.cnDescribe,
                        callback: function ($$v) {
                          _vm.$set(_vm.formWiredData, "cnDescribe", $$v)
                        },
                        expression: "formWiredData.cnDescribe",
                      },
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editStatus,
                            expression: "editStatus",
                          },
                        ],
                        staticClass: "app-text",
                      },
                      [_vm._v(_vm._s(_vm.formWiredData.cnDescribe || "-"))]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-img",
                    class: [{ "no-edit-item": _vm.editStatus }],
                    attrs: { label: "产品图片" },
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.editStatus,
                            expression: "!editStatus",
                          },
                        ],
                        staticClass: "product-img",
                      },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "upload-img",
                            attrs: {
                              action: "/admin/sys-file/upload",
                              headers: _vm.headers,
                              "show-file-list": false,
                              "on-success": _vm.handleAvatarSuccess,
                              "before-upload": _vm.beforeUpload,
                            },
                          },
                          [
                            _vm.formWiredData.pictureUrl
                              ? _c("img", {
                                  staticClass: "uploaded-img",
                                  attrs: {
                                    src:
                                      _vm.uploadWiredUrl ||
                                      _vm.formWiredData.pictureUrl,
                                  },
                                })
                              : _c("div", [
                                  _c("i", {
                                    staticClass:
                                      "iconfont icon-shangchuantupian",
                                  }),
                                  _c("div", { staticClass: "text" }, [
                                    _vm._v("点击上传"),
                                  ]),
                                ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editStatus,
                            expression: "editStatus",
                          },
                        ],
                      },
                      [
                        _vm.formWiredData.pictureUrl
                          ? _c("img", {
                              attrs: {
                                src: _vm.formWiredData.pictureUrl,
                                alt: "",
                              },
                            })
                          : _c("span", [_vm._v("-")]),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "app" }, [
              _c("div", { staticClass: "title" }, [_vm._v("APP内预览效果")]),
              _c("div", { staticClass: "display-area" }, [
                _c("div", { staticClass: "area-title" }, [_vm._v("网络配置")]),
                _c("div", {
                  staticClass: "desc",
                  domProps: { innerHTML: _vm._s(_vm.formattedTextWired) },
                }),
                !_vm.editStatus
                  ? _c("div", { staticClass: "img" }, [
                      _vm.uploadWiredUrl || _vm.formWiredData.pictureUrl
                        ? _c("img", {
                            attrs: {
                              src:
                                _vm.uploadWiredUrl ||
                                _vm.formWiredData.pictureUrl,
                              alt: "",
                            },
                          })
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm.editStatus
                  ? _c("div", { staticClass: "img" }, [
                      _vm.formWiredData.pictureUrl
                        ? _c("img", {
                            attrs: {
                              src: _vm.formWiredData.pictureUrl,
                              alt: "",
                            },
                          })
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeName === 5,
                expression: "activeName === 5",
              },
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "peiwang",
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "content",
                attrs: {
                  model: _vm.formEngineeringData,
                  "label-width": "80px",
                  "label-position": "left",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "指引说明" } },
                  [
                    _c("el-input", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editStatus,
                          expression: "!editStatus",
                        },
                      ],
                      attrs: {
                        type: "textarea",
                        maxlength: "200",
                        "show-word-limit": "",
                        rows: 6,
                      },
                      model: {
                        value: _vm.formEngineeringData.cnDescribe,
                        callback: function ($$v) {
                          _vm.$set(_vm.formEngineeringData, "cnDescribe", $$v)
                        },
                        expression: "formEngineeringData.cnDescribe",
                      },
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editStatus,
                            expression: "editStatus",
                          },
                        ],
                        staticClass: "app-text",
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.formEngineeringData.cnDescribe || "-")
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-img",
                    class: [{ "no-edit-item": _vm.editStatus }],
                    attrs: { label: "产品图片" },
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.editStatus,
                            expression: "!editStatus",
                          },
                        ],
                        staticClass: "product-img",
                      },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "upload-img",
                            attrs: {
                              action: "/admin/sys-file/upload",
                              headers: _vm.headers,
                              "show-file-list": false,
                              "on-success": _vm.handleAvatarSuccess,
                              "before-upload": _vm.beforeUpload,
                            },
                          },
                          [
                            _vm.formEngineeringData.pictureUrl
                              ? _c("img", {
                                  staticClass: "uploaded-img",
                                  attrs: {
                                    src:
                                      _vm.uploadEngineeringUrl ||
                                      _vm.formEngineeringData.pictureUrl,
                                  },
                                })
                              : _c("div", [
                                  _c("i", {
                                    staticClass:
                                      "iconfont icon-shangchuantupian",
                                  }),
                                  _c("div", { staticClass: "text" }, [
                                    _vm._v("点击上传"),
                                  ]),
                                ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editStatus,
                            expression: "editStatus",
                          },
                        ],
                      },
                      [
                        _vm.formEngineeringData.pictureUrl
                          ? _c("img", {
                              attrs: {
                                src: _vm.formEngineeringData.pictureUrl,
                                alt: "",
                              },
                            })
                          : _c("span", [_vm._v("-")]),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "app" }, [
              _c("div", { staticClass: "title" }, [_vm._v("APP内预览效果")]),
              _c("div", { staticClass: "display-area" }, [
                _c("div", { staticClass: "area-title" }, [_vm._v("网络配置")]),
                _c("div", {
                  staticClass: "desc",
                  domProps: { innerHTML: _vm._s(_vm.formattedTextEngineering) },
                }),
                !_vm.editStatus
                  ? _c("div", { staticClass: "img" }, [
                      _vm.uploadEngineeringUrl ||
                      _vm.formEngineeringData.pictureUrl
                        ? _c("img", {
                            attrs: {
                              src:
                                _vm.uploadEngineeringUrl ||
                                _vm.formEngineeringData.pictureUrl,
                              alt: "",
                            },
                          })
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm.editStatus
                  ? _c("div", { staticClass: "img" }, [
                      _vm.formEngineeringData.pictureUrl
                        ? _c("img", {
                            attrs: {
                              src: _vm.formEngineeringData.pictureUrl,
                              alt: "",
                            },
                          })
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeName === 6,
                expression: "activeName === 6",
              },
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "youxian",
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "content",
                attrs: {
                  model: _vm.formEngineeringWiredData,
                  "label-width": "80px",
                  "label-position": "left",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "指引说明" } },
                  [
                    _c("el-input", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editStatus,
                          expression: "!editStatus",
                        },
                      ],
                      attrs: {
                        type: "textarea",
                        maxlength: "200",
                        "show-word-limit": "",
                        rows: 6,
                      },
                      model: {
                        value: _vm.formEngineeringWiredData.cnDescribe,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.formEngineeringWiredData,
                            "cnDescribe",
                            $$v
                          )
                        },
                        expression: "formEngineeringWiredData.cnDescribe",
                      },
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editStatus,
                            expression: "editStatus",
                          },
                        ],
                        staticClass: "app-text",
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.formEngineeringWiredData.cnDescribe || "-")
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "form-item-img",
                    class: [{ "no-edit-item": _vm.editStatus }],
                    attrs: { label: "产品图片" },
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.editStatus,
                            expression: "!editStatus",
                          },
                        ],
                        staticClass: "product-img",
                      },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "upload-img",
                            attrs: {
                              action: "/admin/sys-file/upload",
                              headers: _vm.headers,
                              "show-file-list": false,
                              "on-success": _vm.handleAvatarSuccess,
                              "before-upload": _vm.beforeUpload,
                            },
                          },
                          [
                            _vm.formEngineeringWiredData.pictureUrl
                              ? _c("img", {
                                  staticClass: "uploaded-img",
                                  attrs: {
                                    src:
                                      _vm.uploadEngineeringWiredUrl ||
                                      _vm.formEngineeringWiredData.pictureUrl,
                                  },
                                })
                              : _c("div", [
                                  _c("i", {
                                    staticClass:
                                      "iconfont icon-shangchuantupian",
                                  }),
                                  _c("div", { staticClass: "text" }, [
                                    _vm._v("点击上传"),
                                  ]),
                                ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editStatus,
                            expression: "editStatus",
                          },
                        ],
                      },
                      [
                        _vm.formEngineeringWiredData.pictureUrl
                          ? _c("img", {
                              attrs: {
                                src: _vm.formEngineeringWiredData.pictureUrl,
                                alt: "",
                              },
                            })
                          : _c("span", [_vm._v("-")]),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "app" }, [
              _c("div", { staticClass: "title" }, [_vm._v("APP内预览效果")]),
              _c("div", { staticClass: "display-area" }, [
                _c("div", { staticClass: "area-title" }, [_vm._v("网络配置")]),
                _c("div", {
                  staticClass: "desc",
                  domProps: {
                    innerHTML: _vm._s(_vm.formattedTextEngineeringWired),
                  },
                }),
                !_vm.editStatus
                  ? _c("div", { staticClass: "img" }, [
                      _vm.uploadEngineeringWiredUrl ||
                      _vm.formEngineeringWiredData.pictureUrl
                        ? _c("img", {
                            attrs: {
                              src:
                                _vm.uploadEngineeringWiredUrl ||
                                _vm.formEngineeringWiredData.pictureUrl,
                              alt: "",
                            },
                          })
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm.editStatus
                  ? _c("div", { staticClass: "img" }, [
                      _vm.formEngineeringWiredData.pictureUrl
                        ? _c("img", {
                            attrs: {
                              src: _vm.formEngineeringWiredData.pictureUrl,
                              alt: "",
                            },
                          })
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeName === 3,
                expression: "activeName === 3",
              },
            ],
            staticClass: "scene",
          },
          [
            _c(
              "el-form",
              { staticClass: "func-form", attrs: { model: _vm.funcForm } },
              [
                _c(
                  "div",
                  { staticClass: "condition" },
                  [
                    _c("div", { staticClass: "title" }, [_vm._v("条件设置")]),
                    _c("div", { staticClass: "desc" }, [
                      _vm._v("在App中可以作为场景条件进行选择"),
                    ]),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            on: { change: _vm.handleCheckedCondition },
                            model: {
                              value: _vm.checkboxConditionValue,
                              callback: function ($$v) {
                                _vm.checkboxConditionValue = $$v
                              },
                              expression: "checkboxConditionValue",
                            },
                          },
                          _vm._l(_vm.sceneConditionData, function (item) {
                            return _c(
                              "el-checkbox",
                              {
                                key: item.showId,
                                attrs: {
                                  label: item.showId,
                                  disabled: _vm.editStatus,
                                },
                              },
                              [_vm._v(_vm._s(item.name))]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "action" },
                  [
                    _c("div", { staticClass: "title" }, [_vm._v("动作设置")]),
                    _c("div", { staticClass: "desc" }, [
                      _vm._v("在App中可以作为场景动作进行选择"),
                    ]),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            on: { change: _vm.handleCheckedAction },
                            model: {
                              value: _vm.checkboxActionValue,
                              callback: function ($$v) {
                                _vm.checkboxActionValue = $$v
                              },
                              expression: "checkboxActionValue",
                            },
                          },
                          _vm._l(_vm.sceneActionData, function (item) {
                            return _c(
                              "el-checkbox",
                              {
                                key: item.showId,
                                attrs: {
                                  label: item.showId,
                                  disabled: _vm.editStatus,
                                },
                              },
                              [_vm._v(_vm._s(item.name))]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeName === 4,
                expression: "activeName === 4",
              },
            ],
            staticClass: "json-editor",
          },
          [
            _c(
              "el-form",
              {
                attrs: {
                  model: _vm.formDataJson,
                  "label-width": "50px",
                  "label-position": "left",
                },
              },
              [
                _vm._l(_vm.formDataJson.items, function (item, index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "Key" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入键",
                                      disabled: _vm.editStatus,
                                    },
                                    model: {
                                      value: item.key,
                                      callback: function ($$v) {
                                        _vm.$set(item, "key", $$v)
                                      },
                                      expression: "item.key",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 14 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "Value" } },
                                [
                                  _c("el-input", {
                                    staticClass: "text-value",
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入值",
                                      disabled: _vm.editStatus,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.updateValue(item)
                                      },
                                    },
                                    model: {
                                      value: item.stringValue,
                                      callback: function ($$v) {
                                        _vm.$set(item, "stringValue", $$v)
                                      },
                                      expression: "item.stringValue",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 2 } },
                            [
                              _vm.formDataJson.items.length > 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "danger",
                                        disabled: _vm.editStatus,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.removeItem(index)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", disabled: _vm.editStatus },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.addItem.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("新增")]
                ),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "btn" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.editStatus,
                  expression: "editStatus",
                },
              ],
              attrs: {
                disabled:
                  _vm.rolesCode === "SALE" || _vm.currentDevelopStatus == 1,
                type: "primary",
                size: "14",
              },
              on: { click: _vm.onEdit },
            },
            [_vm._v("编辑")]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.editStatus,
                  expression: "!editStatus",
                },
              ],
              attrs: { size: "14" },
              on: { click: _vm.handleClose },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.editStatus,
                  expression: "!editStatus",
                },
              ],
              attrs: { type: "primary", size: "14" },
              on: { click: _vm.onSubmit },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }